import { Modal } from 'react-bootstrap'
import { KTIcon } from '../../../_metronic/helpers'
import { useTranslation } from 'react-i18next'

const SoftwareDownload = ({ showModal, hideModal }) => {
    const { t } = useTranslation()

    return (
        <Modal
            id="kt_modal_software_download"
            tabIndex={-1}
            aria-hidden="true"
            dialogClassName="modal-dialog modal-dialog-centered mw-650px"
            show={showModal}
            onHide={hideModal}
            backdrop={true}>
            <div className='modal-content'>
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div
                        className="btn btn-sm btn-icon btn-active-color-primary"
                        onClick={hideModal}
                    >
                        <KTIcon className="fs-1" iconName="cross" />
                    </div>
                </div>
                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">{t("DASHBOARD.FAST_ACCESS.TEST_SOFTWARE_FOR_PRODUCERS")}</h1>
                    </div>
                    <div className="mh-400px scroll-y me-n7 pe-7">
                        <div className="flex items-align-center m-auto">
                            <button
                                className="btn btn-primary btn-lg  ms-6 mb-4"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open("http://airngin.com/apptest");
                                }}
                            >
                                {t("DASHBOARD.DOWNLOAD_ANDROID")}
                            </button>
                            <button
                                className="btn btn-primary btn-lg ms-6 mb-4"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open("https://airngin.com/webapptest/");
                                }}
                            >
                                {t("DASHBOARD.DOWNLOAD_IOS_WEB")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export { SoftwareDownload }
